'use client';

import { useRouter } from 'next/navigation';
import { useIntl } from 'react-intl';
import { useIsBot } from '@packages/tracking/src/hooks/useIsBot/useIsBot';
import { Button } from '@packages/shared/src/ui/Button/Button';
import type { HTMLAttributes } from 'react';
import type { AvailabilityState, RatingProduct } from '@packages/gql/generated/shopping/graphql';
import { useCustomerReviewsTracking } from '../Tracking/useCustomerReviewsTracking/useCustomerReviewsTracking';
import { useCustomerRatingsAndReviewPage } from '../../CustomerRatingsAndReviewsPage/hooks/useCustomerRatingsAndReviewPage/useCustomerRatingsAndReviewPage';

export type ShowAllReviewsCallToActionProps = HTMLAttributes<HTMLDivElement> & {
  articleId: string;
  variationId: string;
  availabilityState: AvailabilityState;
  reviewCount: RatingProduct['reviewCount'];
};

export const ShowAllReviewsCallToAction = ({
  articleId,
  variationId,
  availabilityState,
  reviewCount,
}: ShowAllReviewsCallToActionProps) => {
  const { push } = useRouter();
  const isBot = useIsBot();

  const { formatMessage } = useIntl();

  const { getUrl } = useCustomerRatingsAndReviewPage();

  const { trackShowAllReviewsCallToActionButtonClick } = useCustomerReviewsTracking();

  const onClickHandler = () => {
    if (!isBot) {
      const url = getUrl({
        articleId,
        variationId: availabilityState !== 'UNSELECTED' ? variationId : undefined,
        page: '1',
      });

      if (url !== null) {
        trackShowAllReviewsCallToActionButtonClick(reviewCount.toString());

        push(url, {
          scroll: true,
        });
      }
    }
  };

  return (
    <div className="mt-auto flex justify-center lg:mt-1.5">
      <Button onClick={onClickHandler}>
        {formatMessage(
          {
            defaultMessage: 'Alle Bewertungen ({reviewCount}) anzeigen',
            id: 'customerReviews.showAllReviewsCallToAction.buttonText',
          },
          {
            reviewCount,
          },
        )}
      </Button>
    </div>
  );
};
